<template>
    <application-layout>
        <v-main>
            <v-container>
                <h1 class="mb-4">Manage Manager CRM Settings</h1>
                <v-tabs show-arrows>
                    <v-tab
                      data-testid="manager-tablet-manage-call-tab"
                      class="manager-tablet-manage-call-tab"
                    >
                      Manage Call Results
                    </v-tab>

                    <v-tab-item :style="darkTheme ? darkThemeBgColor : ''">
                        <h2 class="mt-4 mb-2">Manage Call Results</h2>
                        <v-btn
                            data-testid="manager-tablet-add-call-btn"
                            class="manager-tablet-add-call-btn mb-4 mx-0"
                            @click="addCallResult"
                            color="primary"
                            :disabled="loading"
                        >
                            <v-icon>add</v-icon>
                            Add Call Result
                        </v-btn>
                        <div v-if="contactResults.length">
                            <transition-group
                                name="scroll-y-transition"
                                mode="out-in"
                                tag="v-row"
                            >
                                <v-col
                                    cols="4"
                                    v-for="result of contactResults"
                                    :key="result.id"
                                >
                                  <app-input
                                      data-testid="manager-tablet-call-result-input"
                                      class="manager-tablet-call-result-input"
                                      :type="'text'"
                                      label="Call Result"
                                      v-model="result.value"
                                      append-outer-icon="delete"
                                      @click:append-outer="deleteResult(result)"
                                  />
                                </v-col>
                            </transition-group>
                        </div>
                        <div class="headline" v-else>
                            You must include at least one call result.
                        </div>
                        <v-btn
                            data-testid="manager-tablet-save-call-btn"
                            class="manager-tablet-save-call-btn mt-4 mx-0"
                            @click="saveCallResults"
                            color="primary"
                            :loading="loading"
                            :disabled="!canSubmit"
                        >
                            Save Call Results
                        </v-btn>
                    </v-tab-item>
                </v-tabs>
            </v-container>
            <v-snackbar
                color="error"
                right
                v-model="error"
            >
                {{ errorMessage }}
            </v-snackbar>

            <v-snackbar
                color="success"
                right
                v-model="success"
            >
                {{ successMessage }}
            </v-snackbar>
        </v-main>
    </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";

export default {
  data() {
    return {
      error: false,
      errorMessage: "",
      contactResults: [],
      loading: false,
      success: false,
      successMessage: ""
    };
  },

  methods: {
    addCallResult() {
      this.contactResults.push({
        id: this.contactResults.length + 1,
        value: ""
      });
    },

    deleteResult(selectedResult) {
      this.contactResults = this.contactResults.filter(allResults => allResults.id !== selectedResult.id);
    },

    saveCallResults() {
      this.loading = true;

      const payload = {
        ident: "global_crm_contact_results",
        value: JSON.stringify(this.contactResults)
      };

      this.$store.dispatch("updateGlobalSetting", payload)
        .then(() => {
          this.success = true;
          this.successMessage = "Your changes have been saved.";

          this.loading = false;
        })
        .catch(err => {
          this.errorMessage = "Your changes could not be saved.";

          if (err.response && err.response.data && err.response.data.message) {
            this.errorMessage = err.response.data.message;
          }

          this.error = true;
          this.loading = false;
        });
    }
  },

  computed: {
    darkThemeBgColor() {
      return this.$store.state.app.darkThemeBgColor;
    },
    canSubmit() {
      if (!this.contactResults.length) {
        return false;
      } else if (this.contactResults.some(result => !result.value)) {
        return false;
      } else {
        return true;
      }
    },
    largeGlobalSettings: {
      get() {
        return this.$store.state.globalSetting.largeGlobalSettings;
      },
      set(newValue) {
        this.$store.commit("setLargeGlobalSettingsData", newValue);
      }
    },
    darkTheme() {
      return this.$vuetify.theme.dark;
    }
  },

  created() {
    this.loading = true;
    this.$store.dispatch("getAllGlobalSettings")
      .then(resp => {
        const results = resp.data.large_global_settings.find(setting => {
          return setting.ident === "global_crm_contact_results";
        }).value;
        this.contactResults = JSON.parse(results);
        this.loading = false;
      });
  },

  components: {
    ApplicationLayout
  }
};
</script>
